import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { sendAlert } from '../../../actions/utils';
import { ComponentDataTable } from '../../../components';
import columns from './columns';

const ProfileDocumentsDataTable = ({
  endpointIndex,
  additionalEndpoint,
  additionalFilter,
  preName,
  moreData,
  extraParams = {},
  filterFunction,
  sortByDocumentType = false
}) => {
  const dispatch = useDispatch();
  const [onRequest, setOnRequest] = useState(false);
  const [total, setTotal] = useState(0);
  const [rows, setRows] = useState([]);

  const openInNewTab = url => window.open(url, '_blank', 'noopener,noreferrer');

  const handleView = item => {
    const fileUrl = item?.document_info?.file_url;
    if (fileUrl) openInNewTab(fileUrl);
    else dispatch(sendAlert({ kind: 'warning', message: 'Este documento no tiene archivo para visualizar.' }));
  };

  const handleDownload = item => {
    const fileUrl = item?.document_info?.file_url;
    if (fileUrl) {
      openInNewTab(fileUrl);
      dispatch(sendAlert({ kind: 'success', message: 'Documento abierto en una nueva pestaña.' }));
    } else {
      dispatch(sendAlert({ kind: 'warning', message: 'Este documento no tiene archivo para descargar.' }));
    }
  };

  const handleActions = (item, action) => {
    switch (action) {
      case 'show':
        handleView(item);
        break;
      case 'download':
        handleDownload(item);
        break;
      default:
        break;
    }
  };

  const handleSuccessIndex = (response, isAdditional = false) => {
    const { data } = response?.data || {};
    let filteredData = (data || []).filter(r => !!r?.is_public);

    if (isAdditional && additionalFilter) {
      filteredData = additionalFilter(filteredData);
    } else if (!isAdditional && filterFunction) {
      filteredData = filterFunction(filteredData);
    }

    return filteredData;
  };

  const sortData = data => {
    if (!sortByDocumentType) return data;

    return [...data].sort((a, b) => {
      const aHasType = a?.document_type !== null;
      const bHasType = b?.document_type !== null;

      if (aHasType && !bHasType) return -1;
      if (!aHasType && bHasType) return 1;
      return 0;
    });
  };

  const resourceRequest = (params = {}) => {
    setOnRequest(true);

    const requestParams = { ...params, ...extraParams, is_public: true };
    let mainData = [];
    let additionalData = [];
    let completedRequests = 0;
    const totalRequests = additionalEndpoint ? 2 : 1;

    const finalize = all => {
      const sorted = sortByDocumentType ? sortData(all) : all;
      setRows(sorted);
      setTotal(sorted.length);
      setOnRequest(false);
    };

    const checkComplete = () => {
      completedRequests += 1;
      if (completedRequests === totalRequests) {
        finalize([...additionalData, ...mainData]);
      }
    };

    endpointIndex({
      dispatch,
      params: requestParams,
      successCallback: response => {
        mainData = handleSuccessIndex(response, false);
        checkComplete();
      },
      callback: () => {
        if (!additionalEndpoint) {
          finalize(mainData);
        }
      }
    });

    if (additionalEndpoint) {
      additionalEndpoint({
        dispatch,
        params: requestParams,
        successCallback: response => {
          additionalData = handleSuccessIndex(response, true);
          checkComplete();
        },
        callback: checkComplete
      });
    }
  };

  return (
    <div className="data-table-yellow">
      <ComponentDataTable
        onRequest={onRequest}
        columns={columns(handleActions)}
        data={rows}
        totalRows={total}
        resourceRequest={resourceRequest}
        moreData={moreData}
        preName={preName}
        pointerOnHover
      />
    </div>
  );
};

export default ProfileDocumentsDataTable;
